// extracted by mini-css-extract-plugin
export default {"card":"Modal_card__Fgato","modal":"Modal_modal__Em9y6","backdrop":"Modal_backdrop__ySlSm","close-btn":"Modal_close-btn__D0yVb"};